<div class="relative flex flex-col min-w-0 break-words w-full">

    @let loading = (loading$ | async);
    @let isSearching = (isSearching$ | async);
    @let showingSearchResults = (showingSearchResults$ | async);

    <list-utils-bar (valueChanged)="onSearchTermChange($event)" [isSearching]="isSearching$"
        [showingResults]="showingSearchResults$" (onSearch)="onSearch($event)" (onCancel)="onCancelSearch()"
        (onRefresh)="onRefresh()"></list-utils-bar>

    @for (item of members$ | async; track item.id) {
    <div #itemRef [attr.data-id]="item.id"
        class="bg-white shadow-lg rounded w-full p-4 mb-4 flex flex-row justify-between transition-colors duration-1000"
        [class.bg-yellow-400]="item.id === firstNewItemId">
        <div class="flex items-start flex-row flex-nowrap cursor-pointer" [routerLink]="['../students', item.memberId]">
            @if(item.photoURL) {
            <img [src]="item.photoURL"
                class="min-h-10 max-h-10 max-w-10 min-w-10 bg-gray-100 object-cover rounded-full border-none" />
            } @else {
            <div
                class="bg-primary-100 uppercase text-primary-500 text-base flex justify-center items-center text-center min-h-10 max-h-10 max-w-10 min-w-10 rounded-full">
                {{ item.name | initials }}
            </div>
            }
            <div class="flex flex-col px-3">
                <div class="flex-1 inline-flex flex-span text-sm font-bold text-blueGray-600">
                    <span>{{item.name ?? '' | titlecase }}</span>
                </div>
                <div class="flex flex-row items-center flex-nowrap">
                    <span
                        class="text-sm capitalize font-light {{item.gradeName != undefined && item.gradeName != 'unassigned' ? 'text-primary-300' : 'text-red-400'}}">
                        {{item.gradeName ??
                        'Unassigned'}}</span>
                    <div class="rounded-full max-h-1 w-1 h-1 py-auto whitespace-nowrap max-w-1 bg-primary-200 mx-2">
                    </div>
                    <span
                        class="text-sm capitalize font-light {{item.parentName != undefined && item.parentName != 'unassigned' ? 'text-primary-300' : 'text-red-400'}}">
                        {{item.parentName ??
                        'Parent Unassigned' | titlecase }}</span>
                </div>
                <div class="flex flex-row gap-2 items-center mt-2">
                    <app-btn-chip [label]="item.status ?? 'Status Unknown'" color="text-green-700"
                        bgColor="bg-green-100"></app-btn-chip>
                    <app-btn-chip [label]="item.gradeYear ? item.gradeYear.toString() : 'Year Unknown'"
                        color="text-secondary-700" bgColor="bg-secondary-100"></app-btn-chip>
                </div>
            </div>
        </div>
        <div class="flex flex-row gap-1 whitespace-nowrap">
            <app-btn-fab (click)="onAssignRole(item)" icon="fas fa-id-card-clip" tooltip="Change Role"></app-btn-fab>
            <app-change-member-status [item]="item"></app-change-member-status>
        </div>
    </div>
    } @empty {
    @if(!(loading || isSearching)) {
    <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap">
        No Students Found
    </div>
    } @else {
    <loading-member></loading-member>
    }
    }
</div>
@if(!(isSearching || showingSearchResults)) {
<div class="flex flex-row w-full justify-center -mt-2">
    <app-btn-more (click)="addMore()" [isDisabled]="(loading$ | async) ?? false"></app-btn-more>
</div>
}